<template>
  <div v-if="!BinaBilgi.Kurulum">
    <div class="sayfahead">
      <h1>{{ BinaBilgi.Adi }} </h1>
      <el-button-group class="float-right">
        <router-link :to="GeriLink" tag="button" class="el-button YeniBtn el-button--primary el-button--small">
          <i class="el-icon-arrow-left"></i>
          Liste
        </router-link>
        <el-button type="info" v-if="$store.getters.Paket!=2" size="small" class="YeniBtn"
                   @click="OimYetkiModalDurum=true">
          OİM Yetki
        </el-button>
        <el-button type="info" v-if="VezneYetki" size="small" class="YeniBtn" @click="DevirModal=true">
          Devir Ödeme
        </el-button>
        <el-button type="info" v-if="MuhasebeYetki" size="small" class="YeniBtn" @click="BilgiModal=true">
          Bilgi Kartı
        </el-button>
        <el-button type="info" size="small" v-if="Yetki" class="YeniBtn" @click="ModalOlayi=true">
          Düzenle
        </el-button>
      </el-button-group>
    </div>
    <div class="icerik">
      <BilgiKarti v-if="!MuhasebeYetki" :BinaBilgi="BinaBilgi"></BilgiKarti>
      <div class="Ekran" v-if="MuhasebeYetki">
        <el-tabs v-model="AktifStep">
          <el-tab-pane name="ozet" :lazy=true>
            <span slot="label" class="tx-IBM"><i class="feather-cast"></i> ÖZET</span>
            <BinaOzetEkran :data="BinaBilgi"></BinaOzetEkran>
          </el-tab-pane>
          <el-tab-pane name="donem" :lazy=true>
            <span slot="label" class="tx-IBM"><i class="feather-calendar"></i> DÖNEM</span>
            <BinaDonem :BinaBilgi="BinaBilgi" :DonemTitle="DonemTitle"></BinaDonem>
          </el-tab-pane>
          <el-tab-pane name="toplanti" :lazy=true>
            <span slot="label" class="tx-IBM"><i class="feather-users"></i> TOPLANTI</span>
            <BinaToplanti :BinaBilgi="BinaBilgi"></BinaToplanti>
          </el-tab-pane>
          <el-tab-pane name="pos" :lazy=true>
            <span slot="label" class="tx-IBM"><i class="feather-credit-card"></i> SANAL POS</span>
            <BinaPos :BinaBilgi="BinaBilgi"></BinaPos>
          </el-tab-pane>
          <el-tab-pane name="teklif" :lazy=true>
            <span slot="label" class="tx-IBM"><i class="feather-minimize-2"></i> TALEP VE TEKLİF</span>
            <BinaTeklif :Bina_id="BinaBilgi.id"></BinaTeklif>
          </el-tab-pane>
          <el-tab-pane name="destek" :lazy=true>
            <span slot="label" class="tx-IBM"><i class="feather-message-square"></i> TEKNİK DESTEK </span>
            <BinaDestek :Kisi_id="null" :Bina_id="BinaBilgi.id"></BinaDestek>
          </el-tab-pane>
<!--          <el-tab-pane name="sgk" :lazy=true>-->
<!--            <span slot="label"><i class="el-icon-s-check"></i> SGK Entegrasyon</span>-->
<!--            <BinaSgk :Bina_id="BinaBilgi.id"></BinaSgk>-->
<!--          </el-tab-pane>-->
          <el-tab-pane name="sayacokuma" :lazy=true>
            <span slot="label" class="tx-IBM"><i class="feather-clock"></i> SAYAÇ YÖNETİMİ</span>
            <BinaEsayac :Bina_id="BinaBilgi.id"></BinaEsayac>
          </el-tab-pane>
          <el-tab-pane name="asansor" :lazy=true>
            <span slot="label" class="tx-IBM"><i class="feather-sliders"></i> ASANSÖR YÖNETİMİ</span>
            <BinaAsansor :Bina_id="BinaBilgi.id"></BinaAsansor>
          </el-tab-pane>
          <!--el-tab-pane :disabled="!this.$store.getters.Uruns.Mbs[10]" name="radius" :lazy=true>
            <span slot="label"><i class="el-icon-mouse"></i> İnternet</span>
            <Radius :Bina_id="BinaBilgi.id"></Radius>
          </el-tab-pane-->
        </el-tabs>
      </div>
    </div>
    <el-dialog
      v-if="MuhasebeYetki"
      :title="BinaBilgi.Adi+' Devir Kasa Tahsilatı'"
      :visible="DevirModal"
      center
      width="30%">
      <a @click="DevirModal=false" class="ModalKapat"><i class="el-icon-close"></i></a>
      <el-form :model="Devir" @submit.prevent.native="DevirOdemeAl" :rules="DevirHata" ref="Form">
        <el-form-item label="Ödeme Tarihi" prop="Tarih">
          <el-date-picker
            v-model="Devir.Tarih"
            type="date"
            placeholder="Ödeme Tarihi"
            format="dd.MM.yyyy"
            value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="Tutar" prop="Tutar">
          <el-input
            placeholder="Tutar"
            v-model="Devir.Tutar">
          </el-input>
        </el-form-item>
        <el-form-item label="Kasa" prop="Kasa_id">
          <el-cascader
            placeholder="Kasa Seçiniz"
            :props="{ multiple: false}"
            :options="Kasalar"
            v-model="Devir.Kasa_id"
            collapse-tags
            filterable></el-cascader>
        </el-form-item>
        <el-form-item label="Açıklama" prop="Aciklama">
          <el-input
            placeholder="Açıklama"
            type="textarea"
            v-model="Devir.Aciklama">
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" size="medium" @click="DevirOdemeAl()" icon="el-icon-check">
          Devir Ödeme Al
        </el-button>
      </div>
    </el-dialog>
    <BinaFormModal
      v-if="Yetki"
      :data="BinaBilgi"
      :ModalOlayi="ModalOlayi"
      :Baslik="BinaBilgi.Adi+' Düzenle'"
      @ModalOlayi="SayfaYukle"></BinaFormModal>
    <el-dialog
      v-if="MuhasebeYetki"
      :title="BinaBilgi.Adi+' Bilgi Kartı'"
      :visible="BilgiModal"
      center
      fullscreen
      width="50%">
      <a @click="BilgiModal=false" class="ModalKapat"><i class="el-icon-close"></i></a>
      <BilgiKarti :BinaBilgi="BinaBilgi"></BilgiKarti>
    </el-dialog>
    <MakbuzDetay v-if="MakbuzDetayModal" :mNo="mNo" @MakbuzDetayModal="MakbuzDetayModal=false"
                 :MakbuzDetayModal="MakbuzDetayModal"></MakbuzDetay>
    <OimYetkiModal v-if="OimYetkiModalDurum" :Modal="OimYetkiModalDurum" @Modal="OimYetkiModalDurum=false"
                   :BinaBilgi="BinaBilgi"></OimYetkiModal>
  </div>
</template>
<script>
import BinaFormModal from '../../../../components/Pack/Yonetim/bina/FormModal'
import BilgiKarti from '../../../../components/Pack/Yonetim/bina/Comp/BilgiKarti'
import BinaDuyuru from "./Comp/BinaDuyuru";
import mWidget from "../../Genel/mWidget";

import BinaOzetEkran from "./Ekran/BinaOzetEkran";
import MakbuzDetay from "../../Vezne/MakbuzDetay";
import BinaDonem from "./Tab/BinaDonem";
import BinaPos from "./Tab/BinaPos";
import BinaTeklif from "./Tab/BinaTeklif";
import BinaToplanti from "./Tab/BinaToplanti";
import BinaDestek from "./Tab/BinaDestek";

import Radius from "../../../../components/Pack/Internet/Radius"
import BinaEsayac from "./Tab/BinaEsayac";
import BinaSgk from "./Tab/BinaSgk";
import BinaAsansor from "./Tab/BinaAsansor";
import OimYetkiModal from "./Comp/OimYetkiModal";

export default {
  components: {
    OimYetkiModal,
    BinaAsansor,
    BinaSgk,
    BinaEsayac,
    BinaDestek,
    BinaToplanti,
    BinaTeklif,
    BinaPos,
    BinaDonem,
    MakbuzDetay,
    BinaOzetEkran,
    mWidget,
    BinaDuyuru,
    BinaFormModal,
    BilgiKarti,
    Radius
  },
  props: {
    BinaBilgi: Object
  },
  data() {
    return {
      GeriLink: "/yonetim/bina",
      DevirModal: false,
      OimYetkiModalDurum: false,
      DonemTitle: "Site Hesapları ortak olduğu için, dönem işlemlerini site üzerinden yapabilirsiniz.",
      MakbuzDetayModal: false,
      mNo: null,
      ModalOlayi: false,
      BilgiModal: false,
      MuhasebeYetki: false,
      Kasalar: null,
      Yetki: false,
      AktifStep: 'ozet',
      Duzenle: this.BinaBilgi.Duzenle,
      Devir: {
        Kasa_id: null,
        Tarih: null,
        Aciklama: null,
        Tutar: 0,
        Bina_id: this.BinaBilgi.id
      },
      BilgiKutu: null,
      BGGoster: true, // BİLGİ KARTI VE DÖNEM
      DevirHata: {
        Kasa_id: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
        Tutar: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
        Tarih: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
        Aciklama: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
      },
    }
  },
  methods: {
    DevirOdemeAl() {
      this.$refs['Form'].validate((valid) => {
        if (valid) {
          // DÜZENLE
          this.$store.dispatch("Post", {
            ...this.Devir,
            path: 'yonetim/bina/ekran/' + this.BinaBilgi.id + '/devir'
          })
            .then(response => {
              if (response.Durum == "OK") {
                this.DevirModal = false;
                this.mNo = response.mNo;
                this.MakbuzDetayModal = true;
                this.$message.success(response.Mesaj);
              } else {
                this.$message.error(response.Mesaj);
                this.hata = response.Hata;
              }
            })
        }
      })

    },
    SayfaYukle() {
      this.ModalOlayi = false;
      this.$store.dispatch("Get", {path: 'muhasebe/kasa/' + this.BinaBilgi.id})
        .then(response => {
          if (response.Durum === 'OK') {
            this.Kasalar = response.Liste
          } else {
            this.$message.error(response.Mesaj);
            this.hata = response.Hata;
          }
        });

    }
  },
  created() {
    if (this.BinaBilgi.Site == "1") {
      this.GeriLink = "/yonetim/site";
      this.DonemTitle = "Dönem işlemlerini bina üzerinden yapabilirsiniz."
    }
    this.VezneYetki = this.$store.getters.Yetki.vezne == '0' ? false : true;
    this.MuhasebeYetki = this.$store.getters.Yetki.muhasebe == '0' ? false : true;
    this.Yetki = this.$store.getters.Yetki.yonetim == '2' ? true : false;
    this.SayfaYukle();
    if (this.BinaBilgi) {
      this.BilgiKutu = {
        Baslik: this.BinaBilgi.Adi,
        Detay: [
          {Baslik: 'Adres', Bilgi: this.BinaBilgi.Adres},
          {Baslik: 'Şehir', Bilgi: this.BinaBilgi.Sehir},
          {Baslik: 'Vergi Dairesi', Bilgi: this.BinaBilgi.vDairesi},
          {Baslik: 'Vergi No', Bilgi: this.BinaBilgi.vNo},
        ]
      }
    }

  },

}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Pack/Yonetim/bina/Ekran.vue